module.exports = __webpack_public_path__ + "img/8400.0b519b78.jpg";